import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'gray' | 'blue' | 'dark';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white'
}: SectionProps) {
  const bgColors = {
    white: 'bg-white',
    gray: 'bg-slate-50',
    blue: 'bg-blue-50/50',
    dark: 'bg-slate-900 text-white'
  };
  return <section id={id} className={`py-16 md:py-24 ${bgColors[background]} ${className}`} data-id="element-15">
      <div className="max-w-6xl mx-auto px-4" data-id="element-16">{children}</div>
    </section>;
}